// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const isDev = process.env.NODE_ENV === 'development';
const release = process.env.APP_VERSION || process.env.NEXT_PUBLIC_APP_VERSION;
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (!isDev) {
    Sentry.init({
        release,
        debug: isDev,
        dsn:
            SENTRY_DSN ||
            'https://48beb7321c0c4b1eb94099c1973c975c@o282461.ingest.sentry.io/6067642',
        // Adjust this value in production, or use tracesSampler for greater control
        tracesSampleRate: isDev ? 0 : 0.25,
        // ...
        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
    });
}
